import { render, staticRenderFns } from "./BillsSettings.vue?vue&type=template&id=aed34748&scoped=true&lang=pug&"
import script from "./BillsSettings.vue?vue&type=script&lang=js&"
export * from "./BillsSettings.vue?vue&type=script&lang=js&"
import style0 from "./BillsSettings.vue?vue&type=style&index=0&id=aed34748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed34748",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VIcon,VTab,VTabItem,VTabs,VTabsItems})
